import type { Retreat } from "shared/types";

type UseRainHistoryImportFormOptionsProps = {
  retreats: Retreat[];
};

export function useRainHistoryImportFormOptions({
  retreats,
}: UseRainHistoryImportFormOptionsProps) {
  const retreatOptions = retreats.map((retreat) => ({
    label: retreat.name,
    value: retreat.id,
  }));

  return { retreatOptions };
}
